'use client'

import { useTranslations } from "next-intl";
import { Button } from "./button";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import { ReactNode, useCallback } from "react";

export default function LoadMoreList({ children, currentLength, maxLength }: { children: ReactNode, currentLength: number, maxLength: number }) {
    const t = useTranslations()
    const router = useRouter()
    const pathname = usePathname()
    const searchParams = useSearchParams()

    const createQueryString = useCallback(
        (name: string, value: string) => {
            const params = new URLSearchParams(searchParams.toString())
            params.set(name, value)

            return params.toString()
        },
        [searchParams]
    )

    return (
        <section className="flex flex-col justify-center gap-12 items-center">
            {children}
            <Button
                disabled={currentLength == maxLength}
                variant="cta"
                className="!bg-neutral !border-neutral !text-primary hover:!bg-primary hover:!text-neutral"
                onClick={() => router.push(pathname + '?' + createQueryString('limit', `${currentLength + 10}`), {scroll: false})}
            >
                {t("page.loadMore")}
            </Button>
        </section>
    )
}